export const environment = {
  production: true,
  WebSocket: null,
  testing: false,
  displayLoadingAnimationOnLaunch: false,
};
